import { CheckEmailResponse, CheckEmailStatusCode } from './checkEmail.model';

export function checkEmailAdapter(
  checkEmailResponse: CheckEmailResponse
): CheckEmailStatusCode {
  return checkEmailResponse.status;
}
